import { connect } from 'react-redux'

import AssociatedContacts from './AssociatedContacts'
import { getAssociatedContacts } from './associatedContacts.actions'

const mapStateToProps = ({
  media: {
    associatedContacts: { loading, error, data },
  },
}) => ({
  isLoading: loading,
  hasError: Boolean(error),
  associatedContacts: data,
})

const mapDispatchToProps = dispatch => ({
  async getAssociatedContacts(contact) {
    await dispatch(getAssociatedContacts(contact))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssociatedContacts)
